import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "kd-icon-triangle",
  "use": "kd-icon-triangle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"kd-icon-triangle\"><path d=\"M795.794286 495.177143A73.142857 73.142857 0 0 0 748.982857 365.714286H275.017143a73.142857 73.142857 0 0 0-46.811429 129.462857l236.982857 197.485714a73.142857 73.142857 0 0 0 93.622858 0z\" p-id=\"1891\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol